import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

class Answer extends React.Component {

  render() {
    const movie = this.props.movie;
    const displayAnswer = this.props.displayAnswer;
    const handleClickOnAnswer = this.props.onAnswer;
    const handleClickOnContinue = this.props.onContinue;

    const answerPanel =
    <div>
      <Typography component="h2" variant="h6">{movie.title}</Typography>
      <Typography component="h3" variant="subtitle1">{movie.director}</Typography>
      <Typography component="p" variant="body2">({movie.year})</Typography>
      <Button variant="contained" color="primary" onClick={handleClickOnContinue}>
        Continue
      </Button>
    </div>;

    const question =
    <div>
      <Button variant="contained" color="primary" onClick={handleClickOnAnswer}>
        Answer
      </Button>
    </div>;

    if(displayAnswer) {
      return answerPanel;
    }
    else {
      return question;
    }
  }
}

export default Answer;